/* SLCT X | Curated by Trek | Quick Add © 2026 Trek */
(()=>{
'use strict';
if(window.__trekQuickAddReady)return;window.__trekQuickAddReady=true;
let busy=false;
function closeSheet(dialog){if(dialog?.open)dialog.close();}
function showError(message,dialog){const el=dialog?.querySelector('[data-tqa-feedback]');if(el)el.textContent=message;else {const toast=document.querySelector('.toast-message');if(toast){toast.textContent=message;toast.hidden=false}}}
async function addVariant(id,source){
  if(busy||!id)return;
  busy=true;const button=source;button.disabled=true;
  const dialog=button.closest('[data-tqa-dialog]');showError('',dialog);
  try{
    const root=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
    const body=new FormData();body.append('id',id);body.append('quantity','1');
    const response=await fetch(root+'cart/add.js',{method:'POST',body,headers:{Accept:'application/json'}});
    const item=await response.json();if(!response.ok)throw Error(item.description||'Unable to add this size');
    closeSheet(dialog);
    const cartTrigger=document.querySelector('[data-cart-trigger]');
    if(cartTrigger && document.getElementById('CartDrawer'))cartTrigger.click();
    else location.assign(root+'cart');
  }catch(error){showError(error.message||'Could not add to cart',dialog)}
  finally{busy=false;button.disabled=false}
}
document.addEventListener('click',event=>{
  const open=event.target.closest('[data-tqa-open]');
  if(open){event.preventDefault();const dialog=open.closest('.trek-quickadd-card')?.querySelector('[data-tqa-dialog]');if(dialog&&!dialog.open)dialog.showModal();return}
  const close=event.target.closest('[data-tqa-close]');if(close){closeSheet(close.closest('[data-tqa-dialog]'));return}
  const select=event.target.closest('[data-tqa-select]');if(select){const dialog=select.closest('[data-tqa-dialog]');dialog.querySelectorAll('[data-tqa-select]').forEach(btn=>{const active=btn===select;btn.classList.toggle('is-selected',active);btn.setAttribute('aria-pressed',String(active))});dialog.querySelector('[data-tqa-confirm]').dataset.tqaVariant=select.dataset.tqaSelect;dialog.querySelector('.trek-qa-price').textContent=select.dataset.tqaPrice;return}
  const direct=event.target.closest('[data-tqa-add]');if(direct){event.preventDefault();addVariant(direct.dataset.tqaAdd,direct);return}
  const confirm=event.target.closest('[data-tqa-confirm]');if(confirm){event.preventDefault();addVariant(confirm.dataset.tqaVariant,confirm)}
});
document.addEventListener('click',event=>{if(event.target.matches?.('[data-tqa-dialog]'))closeSheet(event.target)});
})();
